export const FAVORITE_PROJECTS_STORAGE_PREFIX = 'youkuai.favorite-projects';

type FavoriteStorageReader = Pick<Storage, 'getItem'>;
type FavoriteStorageWriter = Pick<Storage, 'setItem'>;

export function favoriteProjectsStorageKey(accountId: string): string {
  return `${FAVORITE_PROJECTS_STORAGE_PREFIX}:${accountId}`;
}

export function readFavoriteProjectIds(storage: FavoriteStorageReader | null | undefined,
  accountId: string): string[] {
  if (!accountId) return [];
  try {
    const value: unknown = JSON.parse(storage?.getItem(favoriteProjectsStorageKey(accountId)) ?? '[]');
    if (!Array.isArray(value)) return [];
    return [...new Set(value.filter((item): item is string => typeof item === 'string' && item.length > 0))].slice(0, 50);
  } catch {
    return [];
  }
}

export function writeFavoriteProjectIds(storage: FavoriteStorageWriter | null | undefined,
  accountId: string, projectIds: readonly string[]): void {
  if (!accountId) return;
  try {
    storage?.setItem(favoriteProjectsStorageKey(accountId), JSON.stringify([...new Set(projectIds)].slice(0, 50)));
  } catch {
    // 浏览器禁止存储时，仍保留当前页的收藏状态。
  }
}

export function toggleFavoriteProject(projectIds: readonly string[], projectId: string): string[] {
  return projectIds.includes(projectId)
    ? projectIds.filter((item) => item !== projectId)
    : [projectId, ...projectIds.filter((item) => item !== projectId)].slice(0, 50);
}
